import { createAction, props } from '@ngrx/store';
import { DattoConfig } from '@octiga/psa/datto.interface';

export const loadMspDattoConfig = createAction('[MSP Datto] Load Config');
export const loadMspDattoConfigSuccess = createAction(
    '[MSP Datto] Load Config Success',
    props<{ data: DattoConfig }>(),
);
export const loadMspDattoConfigFailure = createAction('[MSP Datto] Load Config Failure', props<{ error: any }>());

export const updateMspDattoConfig = createAction('[MSP Datto] Update Config', props<{ data: DattoConfig }>());
export const updateMspDattoConfigSuccess = createAction('[MSP Datto] Update Config Success');
export const updateMspDattoConfigFailure = createAction('[MSP Datto] Update Config Failure', props<{ error: any }>());
